<script setup>
import {onMounted, provide, ref} from "vue";
import needsService from "@/services/needs.service";
import NeedsDashboardSidebar from "@/views/enterprise/needsDashboard/NeedsDashboardSidebar.vue";
import NeedsEscalated from "@/views/enterprise/needsDashboard/NeedsTable.vue";
import FindMoreSolutionsRequestModal from "@/views/enterprise/needsDashboard/FindMoreSolutionsRequestModal.vue";

const dashboardData = ref(null);
const findMoreSolutionsRequestModal = ref(null);

onMounted(() => {
    getData();
});

async function getData() {
    const {data} = await needsService.getDashboardData();
    dashboardData.value = data;
}

provide("dashboardData", dashboardData);
</script>

<template>
    <div v-if="dashboardData" class="need-admin">
        <NeedsDashboardSidebar/>

        <main class="need-admin__main">
            <ul class="need-admin__stat-overview">
                <li>
                    <big>{{dashboardData.total}}</big>
                    Total Needs
                </li>
                <li>
                    <big>{{dashboardData.in_progress}}</big>
                    Sourcing & Evaluating
                </li>
                <li>
                    <big>{{dashboardData.escalated}}</big>
                    Escalated Needs
                </li>
                <li>
                    <big>{{dashboardData.completed}}</big>
                    Completed
                </li>
            </ul>

            <NeedsEscalated :escalated="true"/>
            <NeedsEscalated :escalated="false"/>

            <div class="need-admin__summary">
                <div>
                    <h5 class="heading5 heading5--secondary">6 needs have under 5 solutions</h5>

                    <p>Unlock AI search to identify high-fit startups</p>
                </div>

                <a @click="findMoreSolutionsRequestModal.open()" class="need-admin__button">Find More Solutions</a>
            </div>
        </main>

        <FindMoreSolutionsRequestModal ref="findMoreSolutionsRequestModal" />
    </div>
</template>

<style scoped>

</style>
